export default {"src":"/_next/static/media/locator-big-red.d8da2f65.svg","height":35,"width":26,"blurWidth":0,"blurHeight":0};